import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import Spinner from '../../../../../components/Spinner/index';
import {
    fetchAllClientInformationData,
    fetchClientInformationData
} from '../../../../../services/redux/employee/clientInformation/actions';
import {
    fetchTrustByClient,
    handleAddTrustVisibility
} from '../../../../../services/redux/employee/trust/actions';
import {
    fetchPortfolioByTrust,
    handleAddPortfolioVisibility
} from '../../../../../services/redux/employee/portfolio/actions';
import {
    fetchClassesByPortfolio,
    handleAddClassVisibility
} from '../../../../../services/redux/employee/classes/actions';

import AddTrust from './AddTrust/index';
import AddPortfolio from './AddPortfolio/index';
import AddClass from './AddClass/index';

class NewRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedClientOption: null,
            selectedTrustOption: null,
            selectedPortfolioOption: null,
            selectedClassesOption: null,
            clientOptions: [],
            trustOptions: [],
            portfolioOptions: [],
            classesOptions: []
        };
    }
    componentDidMount() {
        let {
            fetchAllClientInformationData,
            fetchClientInformationData,
            fetchTrustByClient,
            user,
            roleName
        } = this.props;
        if (roleName === 'Administrator') {
            fetchAllClientInformationData();
        } else if (roleName === 'User') {
            fetchClientInformationData(user.clientId).then(response => {
                if (response && response.clientId) {
                    this.setState({
                        selectedClientOption: {
                            value: response.clientId,
                            label: response.name
                        }
                    });
                    fetchTrustByClient(user.clientId);
                }
            });
        }
    }
    componentWillUnmount() {
        let {
            handleAddTrustVisibility,
            handleAddPortfolioVisibility,
            handleAddClassVisibility
        } = this.props;
        handleAddTrustVisibility(false);
        handleAddPortfolioVisibility(false);
        handleAddClassVisibility(false);
    }

    componentWillReceiveProps(props) {
        if (props.clientInformation !== this.props.clientInformation) {
            let clientOptions = [];
            if (props.clientInformation.clients) {
                props.clientInformation.clients.forEach(client => {
                    clientOptions.push({
                        value: client.clientId,
                        label: client.name
                    });
                });
            }
            this.setState({ clientOptions });
        }
        if (props.trust.trusts !== this.props.trust.trusts) {
            let trustOptions = [
                {
                    value: 'newTrustButton',
                    label: 'New Trust'
                }
            ];
            if (props.trust.trusts) {
                props.trust.trusts.forEach(trust => {
                    trustOptions.push({
                        value: trust.trustId,
                        label: trust.name
                    });
                });
            }
            this.setState({ trustOptions });
            if (props.trust.addedTrust !== this.props.trust.addedTrust) {
                let selectedTrustOption = {
                    value: props.trust.addedTrust.trustId,
                    label: props.trust.addedTrust.name
                };
                this.handleTrustChange(selectedTrustOption);
            }
        }
        if (props.portfolio.portfolios !== this.props.portfolio.portfolios) {
            let portfolioOptions = [
                {
                    value: 'newPortfolioButton',
                    label: 'New Portfolio'
                }
            ];
            if (props.portfolio.portfolios) {
                props.portfolio.portfolios.forEach(portfolio => {
                    portfolioOptions.push({
                        value: portfolio.portfolioId,
                        label: portfolio.name
                    });
                });
            }
            this.setState({ portfolioOptions });
            if (
                props.portfolio.addedPortfolio !==
                this.props.portfolio.addedPortfolio
            ) {
                let selectedPortfolioOption = {
                    value: props.portfolio.addedPortfolio.portfolioId,
                    label: props.portfolio.addedPortfolio.name
                };
                this.handlePortfolioChange(selectedPortfolioOption);
            }
        }
        if (props.classes.classes !== this.props.classes.classes) {
            let classesOptions = [
                {
                    value: 'newClassButton',
                    label: 'New Class'
                }
            ];
            if (props.classes.classes) {
                props.classes.classes.forEach(c => {
                    classesOptions.push({
                        value: c.classId,
                        label: c.name,
                        disabled: true
                    });
                });
            }
            this.setState({ classesOptions });
        }
    }
    handleClientChange = selectedClientOption => {
        let {
            fetchTrustByClient,
            handleAddTrustVisibility,
            handleAddPortfolioVisibility,
            handleAddClassVisibility
        } = this.props;
        this.setState({
            selectedClientOption,
            selectedTrustOption: null,
            selectedPortfolioOption: null,
            selectedClassesOption: null
        });
        handleAddTrustVisibility(false);
        handleAddPortfolioVisibility(false);
        handleAddClassVisibility(false);
        if (selectedClientOption) {
            fetchTrustByClient(selectedClientOption.value);
        } else {
            this.setState({
                trustOptions: []
            });
        }
    };
    handleTrustChange = selectedTrustOption => {
        let {
            fetchPortfolioByTrust,
            handleAddTrustVisibility,
            handleAddPortfolioVisibility,
            handleAddClassVisibility
        } = this.props;
        this.setState({
            selectedTrustOption,
            selectedPortfolioOption: null,
            selectedClassesOption: null
        });
        handleAddTrustVisibility(false);
        handleAddPortfolioVisibility(false);
        handleAddClassVisibility(false);
        if (selectedTrustOption) {
            if (selectedTrustOption.value === 'newTrustButton') {
                handleAddTrustVisibility(true);
            } else {
                fetchPortfolioByTrust(selectedTrustOption.value);
            }
        } else {
            this.setState({
                portfolioOptions: []
            });
        }
    };
    handlePortfolioChange = selectedPortfolioOption => {
        let {
            fetchClassesByPortfolio,
            handleAddTrustVisibility,
            handleAddPortfolioVisibility,
            handleAddClassVisibility
        } = this.props;
        this.setState({
            selectedPortfolioOption,
            selectedClassesOption: null
        });
        handleAddTrustVisibility(false);
        handleAddPortfolioVisibility(false);
        handleAddClassVisibility(false);
        if (selectedPortfolioOption) {
            if (selectedPortfolioOption.value === 'newPortfolioButton') {
                handleAddPortfolioVisibility(true);
            } else {
                fetchClassesByPortfolio(selectedPortfolioOption.value);
            }
        } else {
            this.setState({
                classesOptions: []
            });
        }
    };
    handleClassesChange = selectedClassesOption => {
        let {
            handleAddTrustVisibility,
            handleAddPortfolioVisibility,
            handleAddClassVisibility
        } = this.props;
        this.setState({ selectedClassesOption });
        handleAddTrustVisibility(false);
        handleAddPortfolioVisibility(false);
        handleAddClassVisibility(false);
        if (selectedClassesOption) {
            if (selectedClassesOption.value === 'newClassButton') {
                handleAddClassVisibility(true);
            }
        }
    };
    render() {
        let {
            selectedClientOption,
            selectedTrustOption,
            selectedPortfolioOption,
            selectedClassesOption,
            clientOptions,
            trustOptions,
            portfolioOptions,
            classesOptions
        } = this.state;
        let {
            clientInformation,
            trust,
            portfolio,
            classes,
            roleName
        } = this.props;
        return (
            <div>
                <div className="row">
                    <div className="col-md-6 mb">
                        <Select
                            placeholder="Choose a Client"
                            value={selectedClientOption}
                            onChange={this.handleClientChange}
                            options={clientOptions}
                            disabled={roleName !== 'Administrator'}
                        />
                    </div>
                </div>
                {selectedClientOption && (
                    <div className="row">
                        <div className="col-md-6 mb">
                            <Select
                                placeholder="Choose a Trust"
                                value={selectedTrustOption}
                                onChange={this.handleTrustChange}
                                options={trustOptions}
                            />
                        </div>
                    </div>
                )}
                {selectedTrustOption &&
                    selectedTrustOption.value !== 'newTrustButton' && (
                        <div className="row">
                            <div className="col-md-6 mb">
                                <Select
                                    placeholder="Choose a Portfolio"
                                    value={selectedPortfolioOption}
                                    onChange={this.handlePortfolioChange}
                                    options={portfolioOptions}
                                />
                            </div>
                        </div>
                    )}
                {selectedPortfolioOption &&
                    selectedPortfolioOption.value !== 'newPortfolioButton' && (
                        <div className="row">
                            <div className="col-md-6 mb">
                                <Select
                                    placeholder="Create a Class"
                                    value={selectedClassesOption}
                                    onChange={this.handleClassesChange}
                                    options={classesOptions}
                                />
                            </div>
                        </div>
                    )}
                {trust.addTrustVisibility && (
                    <AddTrust parentClient={selectedClientOption} />
                )}
                {portfolio.addPortfolioVisibility && (
                    <AddPortfolio parentTrust={selectedTrustOption} />
                )}
                {classes.addClassVisibility && (
                    <AddClass parentPortfolio={selectedPortfolioOption} />
                )}
                {classes.fetching && <Spinner />}
                {portfolio.fetching && <Spinner />}
                {trust.fetching && <Spinner />}
                {clientInformation.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    clientInformation: state.employee.clientInformation,
    trust: state.employee.trust,
    portfolio: state.employee.portfolio,
    classes: state.employee.classes,
    user: state.authentication.user,
    roleName: state.authentication.user
        ? state.authentication.user.roleName
        : ''
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchAllClientInformationData,
            fetchClientInformationData,
            fetchTrustByClient,
            fetchPortfolioByTrust,
            fetchClassesByPortfolio,
            handleAddTrustVisibility,
            handleAddPortfolioVisibility,
            handleAddClassVisibility
        },
        dispatch
    );
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(NewRequest));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/NewRequest/screens/index.js